import { isEmpty, isEqual } from 'radash';

/**
 * Same rule as OrganizationsController.saveOrganizationData: drop customValues
 * entries that still match the snapshot loaded from the server. When either
 * side is empty, the incoming map is kept as-is.
 */
function omitUnchangedCustomValues(
    customValues: Record<string, unknown> | undefined | null,
    originalCustomValues: Record<string, unknown> | undefined | null,
): Record<string, unknown> | undefined | null {
    if (isEmpty(customValues) || isEmpty(originalCustomValues)) {
        return customValues;
    }

    const current = customValues as Record<string, unknown>;
    const original = originalCustomValues as Record<string, unknown>;

    return Object.fromEntries(
        Object.entries(current).filter(([key, value]) => !isEqual(value, original[key])),
    );
}

export { omitUnchangedCustomValues };
